import {ordenarColuna, ordenarColunasCombinadas} from "@/components/compra/fornecedor/Tabela/OrdenacaoProdutos";

function setColunasEmOrdenacaoCombinada(state, {order, header}) {
  if (!header.ordenacao_combinada) return;

  if (!order) {
    state.colunas_em_ordenacao_combinada = state.colunas_em_ordenacao_combinada
      .filter(col => col.value !== header.value);
    return;
  }

  const coluna = state.colunas_em_ordenacao_combinada
    .find(col => col.value === header.value);

  if (coluna) {
    coluna.order = order;
    return;
  }

  header.order = order;
  state.colunas_em_ordenacao_combinada.push(header);
}

function getDefaultState() {
    return {
      items: [],
      ordencao_padrao: "peso_compras",
      colunas_em_ordenacao_combinada: [],
      atualizar_tela_compra_count: 0,
    };
  }

  const state = getDefaultState();

  const getters = {
    getItems(state) {
        return state.items;
    },
    getColunaOrdenacaoPadrao(state) {
        return state.ordencao_padrao;
    },
    getColunasEmOrdenacaoCombinada(state) {
        return state.colunas_em_ordenacao_combinada;
    },
    getItensCarrinhoZero () {
      return state.items.filter(item => parseInt(item.carrinho) === 0)
    },
    getAtualizarTelaCompraCount () {
      return state.atualizar_tela_compra_count;
    }
  };

  const mutations = {
    setItems(state, items) {
      state.items = items;
    },
    ordenarItensArray(state, {rules, itens_personalizadas}) {
      const itens  = itens_personalizadas ? itens_personalizadas : state.items;

      setColunasEmOrdenacaoCombinada(state, rules);

      if (rules.header.ordenacao_combinada && state.colunas_em_ordenacao_combinada.length > 0) {
        itens.sort((a, b) => ordenarColunasCombinadas(a, b, rules, itens));
        return;
      }

      itens.sort((a, b) => ordenarColuna(a, b, rules, itens));
    },
    resetColunasEmOrdenacaoCombinada(state) {
      state.colunas_em_ordenacao_combinada = [];
    },
    setAtualizarTelaCompraCount(state) {
      state.atualizar_tela_compra_count = state.atualizar_tela_compra_count + 1;
    },
  };

  const actions = {
    setItems: ({commit}, items) => {
        commit('setItems', items);
    },
    produtosAdicionadosNoCarrinho: ({commit}, produtos) => {
      const callback_map = item => {
        const callback_some = produto => parseInt(produto.id_grupo) === parseInt(item.id_grupo)
          && String(produto.idproduto) === String(item.idproduto);

        const produto_esta_dentro_carrinho = produtos.some(callback_some);

        return {
          ...item,
          carrinho: produto_esta_dentro_carrinho ? 1 : 0
        };
      };

      const callback_filter = item => parseInt(item.carrinho) === 0;

      const novosItens = state.items.filter(callback_filter).map(callback_map);
      commit('setItems', novosItens);
    },
    resetColunasEmOrdenacaoCombinada: ({commit}) => {
      commit('resetColunasEmOrdenacaoCombinada');
    },
    setAtualizarTelaCompraCount: ({commit}) => {
      commit('setAtualizarTelaCompraCount');
    },
  };

  export default { namespaced: true, state, mutations, getters, actions };
